export function isSameKnownBuild(currentSha: string, latestSha?: string): boolean {
  return currentSha !== 'unknown'
    && Boolean(latestSha)
    && currentSha.toLowerCase() === latestSha?.toLowerCase();
}
